export default __webpack_public_path__ + "static/media/cas6–Analysedesmarches.0c4fa4aa.svg";